<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Convenios - {{this.siniestro}}</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">
  <mat-card-content class="py-0">
    <div class="row">
      @for (convenio of [1,2]; track convenio; let i = $index; let odd = $odd; let even = $even) {
        <div class="col-md-12" [ngClass]="even ? 'borde-derecho' : ''"
          >
          @if (convenio ==1) {
            <app-lista-polizas-agentes-convenios [datosConvenio]="this.datosConvenios?.[0]?.contenido" [datosAgentes]="this.datosConvenios?.[1]?.contenido" [agenteNombre]="data.siniestro?.desc_agente"></app-lista-polizas-agentes-convenios>
          }
          @if (convenio ==2) {
            <app-lista-polizas-agentes-convenios [datosConvenio]="this.datosConvenios?.[2]?.contenido" [datosAgentes]="this.datosConvenios?.[3]?.contenido" [agenteNombre]="data.siniestro?.desc_agente"></app-lista-polizas-agentes-convenios>
          }
          <hr class="mt-1 mb-2  border-naranja-seccion">
        </div>
      }
    </div>
  </mat-card-content>
</mat-dialog-content>
<mat-card-actions class="row mx-0 justify-content-end">
  <div class="col-md-auto col-auto">
    <button type="submit" color="primary" class="mx-1 my-1" mat-raised-button (click)="closeDialog('Aceptar')">
      Cerrar
    </button>
  </div>
</mat-card-actions>